import React from 'react'

import classNames from 'classnames'

import printLogoSVG from 'assets/images/logo_no_icon.svg'

import styles from './style.module.scss'

const PrintLogo: React.FC = () => {
  return (
    <div className={classNames(styles.emailView, 'printLogo')}>
      <div className={classNames(styles.container)}>
        <img src={printLogoSVG} alt="logo" />
      </div>
    </div>
  )
}

export default PrintLogo
